import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

export default function EarningDataGrid({ rows, columns }) {
  return (
    <div
      className="radio-shadow border-0"
      style={{ height: 400, width: "100%" }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        slots={{ toolbar: GridToolbar }}
        editable={false}
        // editMode={rows?.length ? false : ""}
        disableSelectionOnClick
      />
    </div>
  );
}
